import React from 'react'
import { connect } from 'react-redux'
import allRoles from '../../roles/roles'
import {
	addListItem, changeListItem, deleteListItem, getListFromValues,
	hasChangedValues, getFormValue, changeItemsValue, nullDate
} from '../../public/utility'
import { doGetInternalExperience, doSaveInternalExperience, doDeleteInternalExperience } from '../../reducers/actions'
import TreeSelect from '../../business/TreeSelect'

class InternalExperienceDiv extends React.Component {
	state = {
	}

	componentDidMount = () => {
		this.doGetInternalExperience()
	}

	doGetInternalExperience = () => {
		const { dispatch, id, personID, type } = this.props
		dispatch(doGetInternalExperience({
			id: id || 0,
			personID: personID || 0,
			type,
			onEnd: ({ errorMessage, initValues基本信息, bDelete }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					this.setState({ id, personID, initValues基本信息, changedValues基本信息: {}, bDelete })
				}
			}
		}))
	}

	handlerSave = () => {
		const { dispatch, onClose, onRefresh, type } = this.props
		const { id, personID, changedValues基本信息, initValues基本信息 } = this.state
		var newChangedValues = changedValues基本信息
		if (id <= 0) {
			newChangedValues = { ...initValues基本信息, ...changedValues基本信息 }
		}
		dispatch(doSaveInternalExperience({
			id: id || 0,
			personID: personID || 0,
			type,
			changedValues基本信息: newChangedValues,
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					Ext.toast('保存成功')
					onRefresh && onRefresh()
					onClose && onClose()
				}
			}
		}))
	}

	handlerDelete = () => {
		const { dispatch, onClose, onSave } = this.props
		const { id } = this.state

		Tyan.pubForm.showConfirm('确定要删除？', () =>
			dispatch(doDeleteInternalExperience({
				id,
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('删除成功')
						onSave && onSave()
						onClose && onClose()
					}
				}
			})))
	}

	handleShowDiv = (initValues, onConfirm, onDelete) => {
		Tyan.pubForm.showDialog(initValues.title, props => <TreeSelect {...props} initValues={initValues} onConfirm={onConfirm} onDelete={onDelete} />)
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	canSave = () => {
		const { type } = this.props
		const { initValues基本信息, changedValues基本信息 } = this.state
		const values = { ...initValues基本信息, ...changedValues基本信息 }
		if (type == '入职') {
			return this.bChanged() && values.fullName && values.任职起日 &&
				values.职等 && values.班别 && values.是否考勤 &&
				(values.是否挂职 == '是' || values.入职日期 && values.入职日期 !== nullDate && values.试用期满日 && values.试用期满日 !== nullDate) && values.员工类别
		}
		else if (type == '离职') {
			return this.bChanged() && values.离职日期 && values.社保 && values.公积金
		}
		else {
			return this.bChanged() && values.任职起日 && values.fullName && values.职等 && values.班别 && values.员工类别
		}
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	fieldset基本信息 = () => {
		const { type, bDelete, bReadOnly } = this.props
		const { initValues基本信息, changedValues基本信息 } = this.state
		const { items班别, items就职来源, items职务 } = initValues基本信息
		const values = { ...initValues基本信息, ...changedValues基本信息 }
		const fields = []
		const 是否挂职 = getFormValue(this, '基本信息', '是否挂职')

		if (type == '入职') {
			fields.push(
				{
					_text: '部门', name: 'fullName', minWidth: '95%', disabled: true, required: true,
					button: {
						text: "...",
						handler: () => this.handleShowDiv(
							{ title: '部门', ...values.obj部门, treeName: values.treeName, treeField: values.treeField },
							(changedValues) => changeItemsValue(this, '基本信息', ['fatherID', 'fullName'], [changedValues['fatherID'], changedValues['fullName']]),
						),
						hidden: !bDelete || bReadOnly
					}
				},
				{ _date: '任职起日', minWidth: '50%', required: true, },
				{ _select: '职等', minWidth: '50%', options: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'], required: true, },
				{ _select: '职务', minWidth: '50%', options: items职务, editable: true },
				{ _text: '职级', minWidth: '50%' },
				{ _text: '职类', minWidth: '50%', },
				{ _select: '班别', minWidth: '50%', options: items班别, required: true, },
				{ _select: '责任区域', minWidth: '50%', options: ['责任制', '非责任制'] },
				{ _select: '是否考勤', minWidth: '50%', options: ['是', '否'], required: true, },
				{ _text: '工作区域', minWidth: '95%', },
				{ _text: '工作地点', minWidth: '95%', },
				{ _date: '入职日期', minWidth: '50%', required: true, cdt: () => 是否挂职 == '否' },
				{ _select: '就职来源', minWidth: '50%', options: items就职来源, editable: true, forceSelection: false },
				{ _select: '员工类别', minWidth: '50%', options: ['本籍直接员工', '本籍间接员工', '外籍直接员工', '外籍间接员工'], required: true, },
				{ _date: '试用期满日', minWidth: '50%', required: true, cdt: () => 是否挂职 == '否' },
				{ _text: '备注', minWidth: '95%', maxRows: 3 })
		}
		else if (type == '离职') {
			fields.push({ _date: '离职日期', minWidth: '50%', required: true, },
				{ _text: '离职原因', minWidth: '50%', },
				{ _select: '社保', minWidth: '95%', options: ['当月停缴', '次月停缴'], required: true, },
				{ _select: '公积金', minWidth: '95%', options: ['当月停缴', '次月停缴'], required: true, },
				{ _select: '医保', minWidth: '95%', options: ['当月停缴', '次月停缴'], required: true, },
				{ _text: '备注', minWidth: '95%', maxRows: 3 })
		}
		else {
			fields.push(
				{ _date: '任职起日', minWidth: '50%', required: true, },
				{ _text: '变更原因', minWidth: '50%' },
				{
					_text: '部门', name: 'fullName', minWidth: '95%', disabled: true, required: true,
					button: {
						text: "...",
						handler: () => this.handleShowDiv(
							{ title: '部门', ...values.obj部门, treeName: values.treeName, treeField: values.treeField },
							(changedValues) => changeItemsValue(this, '基本信息', ['fatherID', 'fullName'], [changedValues['fatherID'], changedValues['fullName']]),
						),
						hidden: !bDelete || bReadOnly
					}
				},
				{ _select: '职务', minWidth: '50%', options: items职务, editable: true },
				{ _select: '职等', minWidth: '50%', options: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'], required: true, },
				{ _text: '职级', minWidth: '50%' },
				{ _text: '职类', minWidth: '50%', },
				{ _select: '班别', minWidth: '50%', options: items班别, required: true, },
				{ _select: '责任区域', minWidth: '50%', options: ['责任制', '非责任制'] },
				{ _select: '是否考勤', minWidth: '50%', options: ['是', '否'], required: true, },
				{ _text: '工作区域', minWidth: '50%', },
				// { _date: '转正日期', minWidth: '50%', required: true, },
				{ _text: '工作地点', minWidth: '50%', },
				{ _select: '员工类别', minWidth: '50%', options: ['本籍直接员工', '本籍间接员工', '外籍直接员工', '外籍间接员工'], required: true, },
				{ _text: '备注', minWidth: '95%', maxRows: 3 })
		}
		return fields
	}

	render() {
		const { showMessage: Message, showBody: Body, bReadOnly } = this.props
		const { errorMessage, id, initValues基本信息, bDelete, } = this.state

		if (errorMessage) return Tyan.pubForm.showError(errorMessage)
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		return <Body data={this} maxWidth="1000"
			controls={
				!bDelete || bReadOnly ? [{ _button: '关闭', icon: 'close', handler: this.handlerClose }] :
					[
						{ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.canSave() },
						{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => id > 0 && bDelete && !bReadOnly },
						{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
					]
			}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: !bDelete || bReadOnly },
				]}
		/>
	}
}

export default connect()(InternalExperienceDiv)